import FinderViewBase from '../FinderViewBase/FinderViewBase';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ProjectFinderHome.html?raw';
import "../ProjectFinder/ProjectFinderHomeTypes";

class ProjectFinderHome extends compose(FinderViewBase) {
	templateString: any = template;
    // must-have attach-points in der template !!!  Klassenproperties sind bereits in der FinderBase deklariert  ------------------------------ start
    //filterPanelContainer: HTMLDivElement;
    //sectionResult: HTMLDivElement;
    //btnSubmitLabel: HTMLElement;
    //btnSubmit: HTMLElement;
    //btnContinue: HTMLElement;
    //btnContinueLabel: HTMLElement;
    //resultMessageErrorContainer: HTMLElement;
    //resultMessageError: HTMLElement;
    //resultContainer: HTMLElement;
    // must-have attach-points in der template !!!  Klassenproperties sind bereits in der FinderBase deklariert   ------------------------------ end

    calendarContainer: HTMLElement; // will be passed as a function parameter
    tableContainer: HTMLElement; // will be passed as a function parameter

    _isCalendarctive: boolean;
    _isTableActive: boolean;
    buttonClickTimeout: number = null;

    // damit man die Name und containerNode im Bedarfsfall nur an einer Stelle ändern muss
    bookingsCalendarParams: calendarParams = { sContainerNodeName: "calendarContainer", domNodeHeight: 500, showButtons: true };
    projectsTableParams: tableParams = { widgetName: "projectsTable", sContainerNodeName: "resultContainer" };

    // das alles bekommen wir dann von der API evtl oder whatever -- parameter die sich nicht ändern
    entityListAttributeName = "items";
    tableEntityPath = "Entity";
    loadFilterDatatUrl = "ProjectFinder/GetProjectList";
    loadFinderConfigUrl = "ProjectFinder/GetFilterpanelOptions";
    btnContinueLabelText = (this as any).translations["AddressFinder_BtnSubmitNext"];
    btnSubmitLabelText = (this as any).translations["AddressFinder_BtnSubmit"];
    calendar_columnViewHeadTextAttr: string = "barview_text"; 
    calendar_columnViewBodyTextAttr: string = "columnview_head_text";


    bookingTable_formatterFunction(cell: StaticTable.StaticTableCell<any>) { // formatter
        let header = cell.name;
        let node = cell.tableCellNode;
        let value = cell.value;

        switch (header) {

            default:
                if (value == null || value == "" || typeof value == "undefined") {
                    value = "N.A.";

                    node.innerHTML = value;
                    return true;
                }
        }

        return false;
    }
    // -------------------------------------- METHODS -----------------------------------------------
    // overrides -----------------------------------------------start
    filterOptions_additionalConfig(): void { //Base
        // weil am anfang die tabelle ausgewählt ist
        var option = this.getFilterOptionByName("displayDate");
        if (option) option.set("readonly", true);
        var option = this.getFilterOptionByName("highlightItems");
        if (option) option.set("highlightItems", true);
    }

    // Evens der Filterpanel fangen
    _onOptionValueChange(dataObj: filterPanel_option_valuechange_obj): void { //Base

        if (dataObj) {
            if (dataObj.name == "resultviewParameter") {
                switch (dataObj.option) {
                    case "view":
                        if (dataObj.optionValue == "calendar") {

                            let startTimeOption = this.getFilterOptionByName("startTime");
                            let endTimeOption = this.getFilterOptionByName("endTime");
                            if (startTimeOption) startTimeOption.set("readonly", true);
                            if (endTimeOption) endTimeOption.set("readonly", true);
                            let displayDateOption = this.getFilterOptionByName("displayDate");
                            if (displayDateOption) displayDateOption.set("readonly", false);
                            let tableLayoutOption = this.getFilterOptionByName("tableLayout");
                            if (tableLayoutOption) tableLayoutOption.set("readonly", true);
                            if (this._isTableActive) this.showCalendar();

                        } else if (dataObj.optionValue == "table") {

                            let startTimeOption = this.getFilterOptionByName("startTime");
                            let endTimeOption = this.getFilterOptionByName("endTime");
                            if (startTimeOption) startTimeOption.set("readonly", false);
                            if (endTimeOption) endTimeOption.set("readonly", false);
                            let displayDateOption = this.getFilterOptionByName("displayDate");
                            if (displayDateOption) displayDateOption.set("readonly", true);
                            let highlightItemsOption = this.getFilterOptionByName("highlightItems");
                            if (highlightItemsOption) {
                                highlightItemsOption.set("value", false);
                                highlightItemsOption.set("readonly", true);
                            }
                            let tableLayoutOption = this.getFilterOptionByName("tableLayout");
                            if (tableLayoutOption) tableLayoutOption.set("readonly", false);
                            if (this._isCalendarctive) this.showTable(true, true);
                        }
                        break;
                    case "tableLayout":

                        if (this._isTableActive) {
                            if (this.projectsTableParams) {

                                let tableParams: TableConfiguration = {
                                    widgetName: this.projectsTableParams.widgetName,
                                    containerNode: this[this.projectsTableParams.sContainerNodeName],
                                    entityList: this._completeList,
                                    tableFormatterfunction: this.bookingTable_formatterFunction,
                                    selectedLayoutName: this.selectedLayoutName
                                }
                                // z.B. gleich eine Tabelle kreieren
                                this._setNestedTable(tableParams);

                            } else {
                                alert("table params?")
                            }
                        }

                        break;
                    case "displayDate":
                        if (this.bookingsCalendarParams) {
                            if (this.calendar && this._isCalendarctive) this.calendar.setDate(dataObj.optionValue);
                        } else {
                            alert("calenadr params?")
                        }
                        break;
                    case "highlightItems":
                        if (this.bookingsCalendarParams) {
                            this._onCalenderHighlightItemChange(dataObj.toggleSelected);
                        } else {
                            alert("calenadr params?")
                        }
                        break;
                }

            } else if (dataObj.name == "searchParameter") {
                switch (dataObj.option) {
                    case "searchText":
                        if (this._isCalendarctive == true) {
                            this.dateRangeStart = null;
                            this.dateRangeEnd = null;
                        }
                        break;
                }
            }
        }
    }

    _onClick_Submit(evt: Event) { // Base

        if (this._isRequestActive === true || (this.getDirty() != true && this._completeList.length >= this.lastResponse.totalResultCount)) {
            return;
        }
        var viewSelectOption = this.getFilterOptionByName("view"); 
        if (viewSelectOption) {
            
            if (viewSelectOption.getValue() == "calendar") {
                this.showCalendar();
            } else if (viewSelectOption.getValue() == "table") {
                this.showTable();
            }
        } else {
            alert("No View selected");
        }
    }

    // was wollen wir mit den FilterDaten anstellen
    processFilterListResponse_callback(): void {
        console.log("TABLE DATA: ", { _completeList: this._completeList });

        if (this.projectsTableParams) {

            let tableParams: TableConfiguration = {
                widgetName: this.projectsTableParams.widgetName,
                containerNode: this[this.projectsTableParams.sContainerNodeName],
                entityList: this._completeList,
                tableFormatterfunction: this.bookingTable_formatterFunction,
                selectedLayoutName: this.selectedLayoutName
            }
            // z.B. gleich eine Tabelle kreieren
            this._setNestedTable(tableParams);

        } else {
            alert("table params?")
        }
    }
    // --------------overrides ------------------------------------end
    // --------------------own methods ----------------------------start

    // je nach dem ob sich die Widgets ersetzen sollen oder synchronisieren usw.
    showTable(bool?: boolean, useLastResponse?:boolean): void {
        if (this.projectsTableParams) {
            if (bool === false) {
                if (this._isTableActive) {
                    if (this[this.projectsTableParams.sContainerNodeName]) {
                        this.UiModder.domClass.add(this[this.projectsTableParams.sContainerNodeName], "w3-hide");
                        if (this._isCalendarctive == false) this.showCalendar();
                        this._isTableActive = false;
                    } else {
                        console.log("no DomNode found for this.", this.projectsTableParams.sContainerNodeName)
                    }
                }
            } else {
                if (useLastResponse) {
                    this.processFilterListResponse(this.lastResponse);
                } else {
                    this.getFilterlist();
                }
                this._isTableActive = true;
                if (this._isCalendarctive) this.showCalendar(false);
            }
        } else {
            alert("calendar params?")
        }
    }

    // je nach dem ob sich die Widgets ersetzen sollen oder synchronisieren usw.
    showCalendar(bool?: boolean): void {
        if (this.bookingsCalendarParams) {

            if (bool === false) {
                if (this._isCalendarctive) {
                    if (this[this.bookingsCalendarParams.sContainerNodeName]) {
                        this.UiModder.domClass.add(this[this.bookingsCalendarParams.sContainerNodeName], "w3-hide");
                        this._isCalendarctive = false;
                        if (this._isTableActive === false) this.showTable(true);

                    } else {
                        console.log("no DomNode found for this.", this.bookingsCalendarParams.sContainerNodeName)
                    }
                }
            } else {
                var displayDateOption = this.getFilterOptionByName("displayDate");
                var displayDate: string = null;
                if (displayDateOption && displayDateOption.selected && displayDateOption.getValue()) {
                    displayDate = <string>displayDateOption.getValue();
                }
                this.createCalendar(
                    this[this.bookingsCalendarParams.sContainerNodeName],
                    this.bookingsCalendarParams.domNodeHeight,
                    this.bookingsCalendarParams.showButtons,
                    this.bookingsCalendarParams.calendarMode,
                    displayDate
                );
                this._isCalendarctive = true;
                if (this._isTableActive) this.showTable(false);
            }
        } else {
            alert("calendar params?")
        }
    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ProjectFinderHome);